import { useEffect } from 'react';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const DashboardTotalContributionsWidget = (props) => {
  const { hits, reachedTheEnd, localURL, setLocalURL } = props;

  const keyPressFunction = (e) => {
    let type;
    if (e.code === 'ArrowRight') {
      type = 'next';
    } else if (e.code === 'ArrowLeft') {
      type = 'prev';
    }
    if (type && !disabledItem({ type })) {
      navigateFunction({ type });
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keyPressFunction);
    return () => {
      document.removeEventListener('keydown', keyPressFunction);
    };
  }, [localURL.hash]);

  const itemPosition = () => {
    let position;
    let currentId = localURL.hash.replace('#contribution-', '');
    if (currentId !== '') {
      position = hits.findIndex((item) => item.contributionId === currentId);
    } else {
      position = -1;
    }
    return position;
  };

  const widgetItemPosition = () => {
    let position = itemPosition();
    if (reachedTheEnd && position + 1 < hits.length) {
      return `${position + 1}-${hits.length}`;
    } else if (position === undefined || position < 0) {
      return null;
    } else {
      return position + 1;
    }
  };

  const disabledItem = ({ type }) => {
    let position = itemPosition();
    if (position !== undefined) {
      if (type === 'next') {
        return position >= hits.length - 1;
      }
      if (type === 'prev') {
        return position <= 0;
      }
    }
    return true;
  };

  const navigateFunction = ({ type }) => {
    let position = itemPosition();
    let newPosition = type === 'next' ? (position += 1) : (position -= 1);
    setLocalURL(
      new URL(
        `${import.meta.env.VITE_APP_APPURL}${localURL.pathname}${localURL.search}#contribution-${
          hits[newPosition].contributionId
        }`
      )
    );
  };

  const searchParam = getUrlParam('search', localURL);
  const topicParam = getUrlParam('topic-id', localURL);

  return (
    <div className='flex-centered'>
      <div className='pl-3 py-3 flex-grow-1 overflow-hidden parliament-live-remarks-widget'>
        <p className='mb-0'>
          {widgetItemPosition() && hits.length > 1 ? `${widgetItemPosition()} of ` : ''}
          {hits.length} {searchParam || (topicParam && topicParam !== 'none') ? 'relevant ' : ''} contribution
          {hits.length === 1 ? '' : 's'}
        </p>
      </div>
      {(hits.length > 1 || (hits.length === 1 && !localURL.hash.includes('contribution-'))) && (
        <div className='flex-centered total-contributions-buttons'>
          {hits?.length > 1 ? (
            <>
              {widgetItemPosition() && (
                <button
                  className={`general-button total-contributions-prev`}
                  disabled={disabledItem({ type: 'prev' })}
                  onClick={() => {
                    navigateFunction({ type: 'prev' });
                  }}
                >
                  <span className='icon-arrow-back'></span>
                </button>
              )}

              <button
                className={`general-button total-contributions-next`}
                disabled={disabledItem({ type: 'next' }) || reachedTheEnd}
                onClick={() => {
                  navigateFunction({ type: 'next' });
                }}
              >
                <span className='icon-arrow-next'></span>
              </button>
            </>
          ) : (
            <button
              className={`general-button total-contributions-next`}
              onClick={() => {
                const search = new URLSearchParams(localURL?.search);
                search.delete('in');
                setLocalURL(new URL(`${import.meta.env.VITE_APP_APPURL}${localURL.pathname}?${search.toString()}`));
              }}
            >
              <span className='icon-arrow-next'></span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardTotalContributionsWidget;
